"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkGroup = void 0;
var _reactI18next = require("react-i18next");
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../../../hooks");
var _ui = require("../../../../ui");
var _form = require("../../form");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NetworkGroup = function NetworkGroup() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var props = (0, _hooks.useWithdrawContext)();
  return /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('network')), /*#__PURE__*/_react.default.createElement(_form.BlockchainSelectInput, {
    value: props.blockchain,
    options: props.blockchains,
    onChange: props.setBlockchain
  }));
};
exports.NetworkGroup = NetworkGroup;